import React, { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { get, map } from "lodash";
import { withTranslation } from "react-i18next";

//i18n
import i18n from "../../../i18n";
import languages from "../../../common/languages";
import RLink from "src/components/Common/UI/Links/RLink";

import styles from './Language.module.css'

const LanguageHorizontalSelector = () => {
  // Declare a new state variable, which we'll call "menu"
  const [selectedLang, setSelectedLang] = useState<string>("");
  const [menu, setMenu] = useState<boolean>(false);

  useEffect(() => {
    const currentLanguage: any = localStorage.getItem("I18N_LANGUAGE");
    setSelectedLang(currentLanguage);
  }, []);

  const changeLanguageAction = (lang: string) => {
    //set language as i18n
    i18n.changeLanguage(lang);
    localStorage.setItem("I18N_LANGUAGE", lang);
    setSelectedLang(lang);
  };

  const toggle = () => {
    setMenu(!menu);
  };

  const activeLanguage= (active:string) =>{
      if(active == selectedLang){
        return styles.activeLang
      }
  }

  return (
    <>
    {Object.keys(languages).map(function(key: string, index:number) {
      return (
        <span key={index}>
          <label className={`${styles.languageSelector} ${activeLanguage(key)}`} 
            onClick={() =>changeLanguageAction(key)}>
            {key.toUpperCase()}
          </label>
          {index + 1 !== Object.keys(languages).length && <span className={styles.divider}>  |  </span> }
        </span>
      )
      
      })}
    </>
  );
};

export default withTranslation()(LanguageHorizontalSelector);